var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Open ' + _vm.params.value),expression:"'Open ' + params.value",modifiers:{"bottom":true}}],staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":_vm.openEnvelope}},[_vm._v("\n    "+_vm._s(_vm.params.data.EnvelopeNumber)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8d328a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-envelopes/OpenEnvelope.vue
// module id = gR0X
// module chunks = 12